import { API } from "@/lib/api";

function urlBase64ToUint8Array(value) {
  const padding = "=".repeat((4 - (value.length % 4)) % 4);
  const base64 = (value + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export const pushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const isIOS = () =>
  /iP(hone|ad|od)/.test(navigator.userAgent) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export const isAndroid = () => /Android/i.test(navigator.userAgent);

export const isStandalone = () =>
  window.navigator.standalone === true ||
  window.matchMedia("(display-mode: standalone)").matches;

export async function getCurrentSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
}

// MUST be called from a user gesture (iOS requirement).
export async function subscribePush() {
  const reg = await navigator.serviceWorker.ready;
  const keyResp = await fetch(`${API}/push/vapid-public-key`, { credentials: "include" });
  if (!keyResp.ok) throw new Error("Impossible de récupérer la configuration push.");
  const { publicKey } = await keyResp.json();

  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("permission-refusee");

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
  }
  const resp = await fetch(`${API}/push/subscribe`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(sub.toJSON()),
  });
  if (!resp.ok) throw new Error("Enregistrement impossible.");
  return sub;
}

export async function unsubscribePush() {
  const sub = await getCurrentSubscription();
  if (!sub) return;
  await fetch(`${API}/push/subscribe?endpoint=${encodeURIComponent(sub.endpoint)}`, {
    method: "DELETE",
    credentials: "include",
  });
  await sub.unsubscribe();
}

// Is THIS device registered on the backend?
export async function backendSubscribed() {
  const sub = await getCurrentSubscription();
  if (!sub) return false;
  const r = await fetch(`${API}/push/status?endpoint=${encodeURIComponent(sub.endpoint)}`, {
    credentials: "include",
  });
  if (!r.ok) return false;
  return (await r.json()).subscribed;
}

export async function sendTestNotification() {
  const r = await fetch(`${API}/push/test`, { method: "POST", credentials: "include" });
  if (!r.ok) throw new Error("Échec de l'envoi");
  return r.json();
}
